// DS: DS2.6.1
import React from 'react';
import ToggleButton from '../ToggleButton/ToggleButton';
import { Props as IconProps } from '@wix/da-ds/pkg/Icons/IconWrap';
import type { BiEvent } from '@wix/da-bi/pkg/events';

import s from './ToggleButtonGroup.scss';

export interface Props {
  value?: string;
  disabled?: boolean;
  buttons: {
    value: string;
    href?: string;
    tooltipText?: string;
    ariaLabel?: string;
    icon: React.ComponentType<IconProps>;
    biData?: BiEvent;
  }[];
  onChange?: (value?: string) => void;
}

const ToggleButtonGroup: React.FC<Props> = ({
  buttons,
  value: selectedValue,
  disabled,
  onChange,
}) => {
  return (
    <div className={s['root']}>
      {buttons.map(
        ({ value, href, tooltipText, ariaLabel, icon, biData }, index) => (
          <ToggleButton
            key={index}
            activated={value === selectedValue}
            tooltipText={tooltipText}
            aria-label={ariaLabel}
            icon={icon}
            disabled={disabled}
            biData={biData}
            href={href}
            onClick={() => {
              if (value !== selectedValue && onChange) {
                onChange(value);
              }
            }}
          />
        )
      )}
    </div>
  );
};

ToggleButtonGroup.displayName = 'ToggleButtonGroup';

export default ToggleButtonGroup;
